import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

// Attach JWT if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vinculo_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Only force redirect if there was a token (i.e. it expired/invalidated).
      // For unauthenticated public pages (landing, demo, login), let the 401 pass silently.
      const hadToken = !!localStorage.getItem("vinculo_token");
      if (hadToken) {
        localStorage.removeItem("vinculo_token");
        localStorage.removeItem("vinculo_user");
        const path = window.location.pathname;
        if (!["/", "/login", "/demo", "/register"].some((p) => path === p || path.startsWith(p + "/"))) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export default api;
